import type { InvoiceTemplate } from '~/api/invoiceTemplates/types';

import { useIntl } from '~/hooks/useIntl';
import { desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { pausedDateStyle } from './invoiceTemplateCell.css';

type Props = {
  invoiceTemplate: InvoiceTemplate;
};

export const InvoiceTemplateNextInvoiceCell = ({ invoiceTemplate }: Props) => {
  const { formatDate } = useIntl();

  return (
    <span className={clsx(desktopTruncateStyle, invoiceTemplate.intervalStatus === 'Paused' && pausedDateStyle)}>
      {invoiceTemplate.nextInvoiceAt !== null ? formatDate(invoiceTemplate.nextInvoiceAt) : '–'}
    </span>
  );
};
